export const entryLogTranslation = {
  textNewEntry: 9935,
  textEgress: 9974,
  textNewEntrySuccess: 9997,
  textEgressSuccess: 9998
};
